import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/INSTITUTION';
export const {action: fetchAll, success: fetchAllSuccess} = createAction(
    `${domain}/FETCH_ALL`,
    () => ({}),
    (institutions, organizationId) => ({institutions, organizationId}),
);

export const {
    action: fetchGroups,
    success: fetchGroupsSuccess,
    failed: fetchGroupsFailed,
} = createAction(
    `${domain}/FETCH_GROUPS`,
    institutionId => ({institutionId}),
    payload => payload,
    (error, institutionId) => ({error, institutionId}),
);

/**
 * @deprecated use the useStatSettings().openingHours  instead
 */
export const {
    action: fetchOpeningHours,
    success: fetchOpeningHoursSuccess,
    failed: fetchOpeningHoursFailed,
} = createAction(
    `${domain}/FETCH_OPENING_HOURS`,
    institutionId => ({institutionId}),
    payload => payload,
    (error, institutionId) => ({error, institutionId}),
);

export const {
    action: updateOpeningHours,
    success: updateOpeningHoursSuccess,
    failed: updateOpeningHoursFailed,
} = createAction(
    `${domain}/UPDATE_OPENING_HOURS`,
    (openingHours, institutionId) => ({openingHours, institutionId}),
    payload => payload,
    (error, institutionId) => ({error, institutionId}),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE`,
    (institution, privacyPolicyUrl, facebookLink, instagramLink, twitterLink, description) => ({
        institution,
        privacyPolicyUrl,
        facebookLink,
        instagramLink,
        twitterLink,
        description,
    }),
    (institution, privacyPolicyUrl, facebookLink, instagramLink, twitterLink, description) => ({
        institution,
        privacyPolicyUrl,
        facebookLink,
        instagramLink,
        twitterLink,
        description,
    }),
);
